// @module BTM.OutOfStockBehaviour.OutOfStockBehaviour
define('BTM.OutOfStockBehaviour.OutOfStockBehaviour.View'
,	[
		'btm_outofstockbehaviour_outofstockbehaviour.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		btm_outofstockbehaviour_outofstockbehaviour_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class BTM.OutOfStockBehaviour.OutOfStockBehaviour.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_outofstockbehaviour_outofstockbehaviour_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/OutOfStockBehaviour.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return BTM.OutOfStockBehaviour.OutOfStockBehaviour.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.OutOfStockBehaviour.OutOfStockBehaviour.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
